/* eslint-disable @sailor/i18n-no-country-codes */
/* eslint-disable multiline-comment-style */
import {  MDateTime, MCity, MCurrency, i18nClient } from '@sailor/i18n-web'
import { getQueryValues } from '.'
import { getDateTimePattern, getLanguage } from './i18n'


// 时间戳解析为日期/时间字符串
const getTimestamp2Str = ({
  timestamp, // 毫秒/秒
  dateStyle = 1, // 日期格式 默认1
  timeStyle = 1, // 时间格式 默认1
  timestampType = 2, // 类型 1毫秒 2秒
  pattern, // 自定义 pattern https://sky.sankuai.com/docs/sailor/sailor_i18n_doc/java-sdk/datetime/pattern.html
  cityId = getCurCityId(), // 默认当前全局城市id
}: {
  timestamp: number
  dateStyle?: number
  timeStyle?: number
  timestampType?: number
  pattern?: string
  cityId?: number
}) => {
  if (!timestamp) return ''
  return pattern
    ? MDateTime.formatByCityIdWithPattern(cityId, timestampType === 1 ? timestamp : timestamp * 1000, pattern, getLanguage())
    : MDateTime.formatByCityId(cityId, timestampType === 1 ? timestamp : timestamp * 1000, dateStyle, timeStyle, getLanguage())
}


// 获取用户所选国家的首都ID
export const getCurCityId = () => MCity.getCapitalCityIdByRegion(getRegion())


export const getI18nTime = (time: number, formater?: string) => getTimestamp2Str({ timestamp: Number(time), timestampType: 1, pattern: formater || getDateTimePattern() })


export function getLocalInfo () {
  try {
    return JSON.parse(localStorage.getItem('FE_LOCAL_INFO') || '{}')
  } catch (error) {
    return {}
  }
}

export function updateLocalInfo (info: {[k:string]: any, region: string, timeZone: string, locale: string}) {
  localStorage.setItem('FE_LOCAL_INFO', JSON.stringify(info))
}
export function getRegion () {
  let region = getQueryValues('region') || getLocalInfo()?.region || 'HK'
  return String(region)
}

export function isEn () {
  return getLanguage() === 'en'
}

export function isZh () {
  return getLanguage() === 'zh' || getLanguage() === 'zh-HK'
}

export function getMoneySymbolConfig () {
  const currentRegion = getRegion()
  const regionConfig = {
    'AE': [
      {
        'region': 'AE',
        'locale': 'en',
        'pattern': '\\bAED\\b',
        'replace': '\uE000',
      },
      {
        'region': 'AE',
        'locale': 'ar',
        'pattern': 'د\\.إ\\.',
        'replace': '\uE000',
      },
      {
        'region': 'AE',
        'locale': 'zh',
        'pattern': '\\bAED\\b',
        'replace': '\uE000',
      },
    ],
    'SA': [
      {
        'region': 'SA',
        'locale': 'en',
        'pattern': '\\bSAR\\b',
        'replace': '\u2068\uFDFC\u2069',
      },
      {
        'region': 'SA',
        'locale': 'ar',
        'pattern': 'ر\\.س\\.',
        'replace': '\uFDFC',
      },
    ],
  }
  // @ts-ignore
  return regionConfig[currentRegion] || []
}

const moneySymbolConfig = getMoneySymbolConfig()
/**
 * 替换字符串中的货币符号, 按照 getMoneySymbolConfig 返回的规则进行替换
 * @param {string} text 需要替换的字符串
 * @param {string} [locale] 可选，指定地区语言信息，优先级高于默认配置
 * @returns {string} 替换后的字符串
 */
export function replaceMoneySymbol (text: string): string {
  if (!text) return ''
  // console.log(i18nClient?.replaceRiyalSymbol, 'i18nClient?.replaceRiyalSymbol')


  return i18nClient?.replaceRiyalSymbol?.(text)

  // const rules = moneySymbolConfig
  // const locale = getLanguage()
  // if (!Array.isArray(rules) || rules.length === 0) return text

  // let replacedText = text

  // // 如传入了 locale，只保留符号相等的规则，否则全部生效
  // const rule = rules.find(rule => rule.locale === locale)
  // if (rule) {
  //   try {
  //     const reg = new RegExp(rule.pattern, 'g')
  //     replacedText = replacedText.replace(reg, rule.replace)
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }

  // return replacedText
}

export function getMoneyCurrency () {
  const currentLang = getLanguage()
  const moneyCurrency = replaceMoneySymbol(MCurrency.getSymbolByCityId(getCurCityId(), currentLang))
  if (currentLang !== 'en') { // 如果货币符号不是英文,则加上空格
    return `${moneyCurrency} `
  }
  return moneyCurrency
}

/**
 * 获取当前区域的货币最小单位倍率（元 → 最小单位的乘数）
 * 例如：HK/SA/AE = 100（分），KW = 1000（费勒），JP = 1（无小数）
 * 对应 MCurrency.getCurrencyInfoConfigByRegion(region).ratio
 */
export function getAmountRatio (): number {
  return MCurrency.getCurrencyInfoConfigByRegion(getRegion())?.ratio || 100
}

/**
 * 将用户输入的元单位金额转换为后端所需的最小货币单位整数
 * @param value 用户输入的金额字符串，如 "30.50"
 * @returns 最小货币单位整数，如 3050（HK）/ 30500（KW）
 */
export function amountToMinorUnit (value: string): number {
  return Math.round(parseFloat(value) * getAmountRatio())
}

/**
 * 获取当前区域货币的小数位数，用于输入校验
 * 例如：HK/SA/AE = 2，KW = 3，JP = 0
 */
export function getAmountFractionPlaces (): number {
  return MCurrency.getCurrencyInfoConfigByRegion(getRegion())?.fractionPlaces || 2
}
